export type PdfSearchMatch = {
  pageNo: number;
  itemIndex: number;
  charStart: number;
  charEnd: number;
};

export type PdfSearchOptions = {
  matchCase?: boolean;
  wholeWord?: boolean;
};

const isWordChar = (char: string) => /[\w\u00C0-\u024F]/.test(char);

const isWholeWordAt = (text: string, start: number, end: number) => {
  const before = start > 0 ? text[start - 1] : "";
  const after = end < text.length ? text[end] : "";
  return !isWordChar(before) && !isWordChar(after);
};

export const findTextInDocument = async (
  pdfDoc: any,
  query: string,
  totalPages: number,
  options: PdfSearchOptions = {}
): Promise<PdfSearchMatch[]> => {
  const trimmedQuery = query.trim();
  if (!trimmedQuery) return [];

  const { matchCase = false, wholeWord = false } = options;
  const normalizedQuery = matchCase ? trimmedQuery : trimmedQuery.toLowerCase();

  const matches: PdfSearchMatch[] = [];
  for (let pageNo = 1; pageNo <= totalPages; pageNo += 1) {
    const page = await pdfDoc.getPage(pageNo);
    const textContent = await page.getTextContent();
    textContent.items.forEach((item: any, itemIndex: number) => {
      if (!item?.str) return;
      const sourceStr = item.str;
      const searchableStr = matchCase ? sourceStr : sourceStr.toLowerCase();
      let start = 0;
      while (start < searchableStr.length) {
        const foundAt = searchableStr.indexOf(normalizedQuery, start);
        if (foundAt === -1) break;
        const charEnd = foundAt + normalizedQuery.length;
        if (!wholeWord || isWholeWordAt(sourceStr, foundAt, charEnd)) {
          matches.push({
            pageNo,
            itemIndex,
            charStart: foundAt,
            charEnd
          });
        }
        start = foundAt + 1;
      }
    });
  }
  return matches;
};
